import { Component, OnChanges, inject, ChangeDetectionStrategy, input, output } from '@angular/core';
import {GuruEntity} from '../../../model/guru-entity';
import {ModelService} from '../../../services/model-service';
import {SelectionUtils} from '../../selection-utils';
import {ConfigurationSection, UserStateService} from '../../../services/user-state.service';
import { FormsModule } from '@angular/forms';

import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-horizontal-cabinet-features',
    templateUrl: './horizontal-cabinet-features.component.html',
    styleUrls: ['./horizontal-cabinet-features.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, FormsModule]
})
export class HorizontalCabinetFeaturesComponent implements OnChanges {
  private modelService = inject(ModelService);
  private userStateService = inject(UserStateService);


  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly valueChanged = output<void>();
  drainPanSelection!: GuruEntity;
  dripLipSelection!: GuruEntity;
  tellTailSelection!: GuruEntity;
  cabinetInsulationSelection!: GuruEntity;
  valvePackageEnclosureSelection!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.CABINET_FEATURES;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.drainPanSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USDrainPan');
    this.dripLipSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USDripLip');
    this.tellTailSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USTellTail');
    this.cabinetInsulationSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCabinetInsulation');
    this.valvePackageEnclosureSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USValveEnclosure');
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

}
